import { useState } from 'react';
// material
import { Container, Typography, Card, Tab, Box, Stack } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';

// components
import Page from '../components/Page';
import PurchaseOrderTable from '../components/PurchaseOrderTable';
import PageHeader from '../components/smallComponents/PageHeader';

export default function PurchaseOrders() {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Page title="Purchase Orders">
        <Container maxWidth="xl">
          <PageHeader title="Purchase Orders" />
          <Card>
            <Box sx={{ width: '100%', marginTop: '20px' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange}>
                    <Tab label="Pending" value="1" />
                    <Tab label="Completed" value="2" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <PurchaseOrderTable status={'PENDING'} />
                </TabPanel>
                <TabPanel value="2">
                  <PurchaseOrderTable status={'COMPLETED'} />
                </TabPanel>
              </TabContext>
            </Box>
          </Card>
        </Container>
      </Page>
    </>
  );
}
